import { LightbulbOnIcon } from './LightbulbOnIcon';

/**
 * author: Austin Andrews
 * id 4B3F67C4-02C3-4083-B47A-645AD24992FA
 * name lightbulb-on
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-on.svg
 * tags
 * - Home Automation 
 */
export const LightbulbDimmer100Icon = LightbulbOnIcon;
export default LightbulbDimmer100Icon